var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgColorsSuccess = function SvgColorsSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.076 16.963-5.38-5.382a1.49 1.49 0 0 1-.328-.48 1.408 1.408 0 0 1 0-1.095c.073-.175.182-.335.328-.48l5.032-5.01L3.41 2.198 4.766.776l8.749 8.75c.146.147.251.307.317.482s.098.358.098.547c0 .19-.032.372-.098.547a1.348 1.348 0 0 1-.317.481l-5.382 5.38a1.489 1.489 0 0 1-.482.329 1.409 1.409 0 0 1-1.093 0 1.487 1.487 0 0 1-.482-.329Zm1.03-11.068-4.682 4.68 9.363.002-4.681-4.682Zm8.727 11.507c-.525 0-.97-.186-1.335-.558a1.878 1.878 0 0 1-.546-1.367c0-.394.098-.766.295-1.116.197-.35.42-.692.667-1.028l.92-1.18.962 1.18c.233.336.452.679.656 1.029.204.35.306.722.306 1.115 0 .54-.19.996-.57 1.368a1.87 1.87 0 0 1-1.355.557Z",
    fill: "#43A2AC"
  })));
};
export default SvgColorsSuccess;